import {FutureCalc, IFutureYear} from "../../../../components/calculator/Calculator";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {numberToMoneyFormat, numberToPercentFormat} from "../../../../stores/StoreUtilities";
import {Gender} from "../../../../API";
import globalStyles from "../../../../styles/globalStyles";


const NetworthProjectionTable = ({
  futureCalc,
  year,
  onChange
}: {
  futureCalc: FutureCalc
  year?: number
  onChange?: (year: number) => any
}) => {
  const [currentYear, setCurrentYear] = useState<number>(0)

  useEffect(() => {
    if (year) {
      setCurrentYear(year)
    }
  }, [year])

  const handleChange = (year: number) => {
    if (onChange) {
      setCurrentYear(year)
      onChange(year)
    }
  }

  const netFirstYearAssets = futureCalc.futureYears[0].netLiquidAssets + futureCalc.futureYears[0].netRealAssets - futureCalc.futureYears[0].netLiabilities

  return (
    <Box display="flex" flexGrow={1} flexDirection="column" mt={2}>
      <Box display="flex" flexGrow={1} justifyContent="space-between" minHeight={40}>
        <Typography variant="h3" color="primary" gutterBottom>Net Worth Projection Details</Typography>
        <Box display="flex" alignItems="center" pt={0}>
          <Box width={14} height={14} sx={globalStyles.trRetired}></Box>
          <Typography variant="body2" style={globalStyles.legendLabel}>Planned Retirement</Typography>
          {futureCalc.person1 &&
            <React.Fragment>
              <Box width={14} height={14} sx={futureCalc.person1.gender === Gender.Male ? globalStyles.trHisLifeExpectancy : globalStyles.trHerLifeExpectancy}></Box>
              <Typography variant="body2" style={globalStyles.legendLabel}>{futureCalc.person1.nickname}'s Life Expectancy</Typography>
            </React.Fragment>
          }
          {futureCalc.person2 &&
            <React.Fragment>
              <Box width={14} height={14} sx={futureCalc.person2.gender === Gender.Male ? globalStyles.trHisLifeExpectancy : globalStyles.trHerLifeExpectancy}></Box>
              <Typography variant="body2" style={globalStyles.legendLabel}>{futureCalc.person2.nickname}'s Life Expectancy</Typography>
            </React.Fragment>
          }
          <Box width={14} height={14} sx={globalStyles.trAssetsDepleted}></Box>
          <Typography variant="body2" style={globalStyles.legendLabel}>Liquid Assets Final Year</Typography>
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table size="small" width="100%">
          <TableHead>
            <TableRow>
              {/*<TableCell width={30}></TableCell>*/}
              <TableCell>Year</TableCell>
              <TableCell align="right">Liquid Assets</TableCell>
              <TableCell align="right">Real Estate Assets</TableCell>
              <TableCell align="right">Liabilities</TableCell>
              <TableCell align="right">Net Worth</TableCell>
              <TableCell align="right">YoY1 Change %</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {futureCalc.futureYears.map((fy: IFutureYear, index: number) => {
              const netLiquidAssets = fy.netLiquidAssets
              const netRealAssets = fy.netRealAssets
              const netLiabilities = fy.netLiabilities
              const netAssets = netLiquidAssets + netRealAssets - netLiabilities
              const yoy1Change = (netAssets / netFirstYearAssets) - 1

              let rowStyle
              if (fy.year === futureCalc.latestRetirementYear) {
                rowStyle = globalStyles.trRetired
              } else if (futureCalc.person1 && fy.year === futureCalc.person1!.lifeExpectancyYear) {
                rowStyle = (futureCalc.person1.gender === Gender.Male) ? globalStyles.trHisLifeExpectancy : globalStyles.trHerLifeExpectancy
              } else if (futureCalc.person2 && fy.year === futureCalc.person2!.lifeExpectancyYear) {
                rowStyle = (futureCalc.person2.gender === Gender.Male) ? globalStyles.trHisLifeExpectancy : globalStyles.trHerLifeExpectancy
              } else if (fy.currentLiquidAssets > 0 && fy.spendableLiquidAssets <= 0) {
                rowStyle = globalStyles.trAssetsDepleted
              }

              return (
                <TableRow selected={currentYear === fy.year} key={`row${index}`} style={rowStyle}
                          onClick={() => {handleChange(fy.year)}}>
                  <TableCell>{fy.year}</TableCell>
                  <TableCell align="right">{numberToMoneyFormat(netLiquidAssets, 0)}</TableCell>
                  <TableCell align="right">{numberToMoneyFormat(netRealAssets, 0)}</TableCell>
                  <TableCell align="right">{numberToMoneyFormat(netLiabilities, 0)}</TableCell>
                  <TableCell align="right">{numberToMoneyFormat(netAssets, 0)}</TableCell>
                  <TableCell align="right">{numberToPercentFormat(yoy1Change, 2)}</TableCell>
                </TableRow>
              )
            }
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default NetworthProjectionTable